import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularBuy: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_buy"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="buy icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C11.5165 2 11.0359 2.08263 10.5849 2.2449C10.1339 2.40717 9.71815 2.6471 9.36355 2.95512C9.00876 3.2633 8.72112 3.6346 8.52262 4.05087C8.32391 4.46755 8.21981 4.91846 8.21981 5.37683V6.5H4.51418C3.49041 6.5 2.68163 7.36166 2.75457 8.37468L3.58518 19.9103C3.66996 21.0877 4.65759 22 5.84754 22H18.1525C19.3424 22 20.33 21.0877 20.4148 19.9103L21.2454 8.37468C21.3184 7.36166 20.5096 6.5 19.4858 6.5H15.7802V5.37683C15.7802 4.91846 15.6761 4.46756 15.4774 4.05087C15.2789 3.6346 14.9912 3.2633 14.6365 2.95512C14.2818 2.6471 13.8661 2.40717 13.4151 2.2449C12.9641 2.08263 12.4835 2 12 2ZM14.2681 6.5V5.37683C14.2681 5.14528 14.2158 4.91302 14.1105 4.6923C14.0051 4.47117 13.8472 4.26331 13.6403 4.08364C13.4333 3.90381 13.1823 3.75676 12.8995 3.65501C12.6167 3.55326 12.3108 3.5 12 3.5C11.6892 3.5 11.3833 3.55326 11.1005 3.65501C10.8177 3.75676 10.5667 3.90381 10.3597 4.08364C10.1528 4.26331 9.99492 4.47117 9.88947 4.6923C9.78422 4.91302 9.73188 5.14528 9.73188 5.37683V6.5H14.2681ZM4.26281 8.26781C4.25239 8.1231 4.36793 8 4.51418 8H19.4858C19.6321 8 19.7476 8.1231 19.7372 8.26781L18.9066 19.8034C18.8783 20.1959 18.5491 20.5 18.1525 20.5H5.84754C5.45089 20.5 5.12168 20.1959 5.09342 19.8034L4.26281 8.26781Z"
        />
        <path d="M12.7564 11.4995C12.7564 11.0853 12.4179 10.7495 12.0003 10.7495C11.5828 10.7495 11.2443 11.0853 11.2443 11.4995V15.2081L9.50671 13.5096C9.20929 13.2189 8.73061 13.2224 8.43754 13.5174C8.14448 13.8125 8.14801 14.2873 8.44543 14.5781L11.47 17.5346C11.7644 17.8223 12.2371 17.8223 12.5314 17.5345L15.5552 14.5776C15.8526 14.2868 15.856 13.8119 15.5629 13.5169C15.2698 13.222 14.7911 13.2186 14.4937 13.5093L12.7564 15.2083V11.4995Z" />
      </svg>
    </span>
  );
};

export { RegularBuy };
